import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import { FitOptions, ValueWithImage } from "src/config/reviewSystemData";
import classNames from "src/helpers/classNames";
import Image from "next/image";

interface FitFormProps {
  fit: ValueWithImage;
  setFit: Dispatch<SetStateAction<ValueWithImage>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  isFormSubmittedOnce: boolean;
}

const FitForm = ({
  fit,
  setFit,
  setReviewStep,
  isFormSubmittedOnce,
}: FitFormProps) => {
  const t = useTranslations("ReviewForm");
  return (
    <>
      <section className="m-auto flex flex-col items-center gap-10">
        <h2 className="text-2xl font-semibold">{t("how_did_it_fit")}</h2>
        <div className="flex flex-col gap-10 lg:flex-row">
          {FitOptions.map((option: ValueWithImage) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setFit(option)}
              className={classNames(
                "flex items-center gap-3 border border-white p-2 hover:border-beige-800",
                option.value === fit.value ? "!border-black" : ""
              )}
            >
              <Image
                src={option.image.src}
                alt="fit-option-icon"
                className="object-contain"
                style={{
                  width: `${option.image.width}px`,
                  height: `${option.image.height}px`,
                }}
                sizes="15rem"
                width={0}
                height={0}
                priority
              />
              {t(option.value)}
            </button>
          ))}
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton
            onClick={() => setReviewStep(9)}
            disabled={fit.value === "" || !fit}
          >
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={fit.value === "" || !fit}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default FitForm;
